import { FieldType, ExtendedFilteringProperty } from "./definitions";

/**
 * Gets visible column keys from preferences
 * Used to determine which columns need unique values loading
 */
export const getVisibleColumnKeys = (preferences: any): Set<string> => {
  if (!preferences?.contentDisplay) return new Set();

  return new Set(
    preferences.contentDisplay
      .filter((col: any) => col.visible)
      .map((col: any) => col.id),
  );
};

/**
 * Gets the field type from an extended filtering property
 * Defaults to "text" if not explicitly specified
 */
export const getFieldType = (
  property: ExtendedFilteringProperty,
): FieldType => {
  return property.fieldType || "text";
};

/**
 * Utility to compare two sets for equality
 * Used to prevent unnecessary state updates when sets contain the same values
 */
export const setsAreEqual = (set1: Set<string>, set2: Set<string>): boolean => {
  if (set1.size !== set2.size) return false;
  for (const item of Array.from(set1)) {
    if (!set2.has(item)) return false;
  }
  return true;
};
